import { Menu, MenuItem } from '@mui/material'
import { useState } from 'react'

import { InspectionEntryStatusChip } from '../../../components/Inspections/InspectionEntryStatusChip'
import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { EntryWithRelated } from '../../../models/inspections'
import { useUpdateInspectionEntryMutation } from '../../../redux/api/inspectionApi'
import { EntryInfoStatusEnum, InspectionEntryStatusEntry } from '../../../sdk'

export const SelectInspectionEntryStatusChip = ({
  entry,
  setEntry,
  allStatuses
}: {
  entry: EntryWithRelated
  setEntry: (entry: EntryWithRelated) => void
  allStatuses: InspectionEntryStatusEntry[] | undefined
}) => {
  const { accessToken } = useAccessTokenAndShopId()

  const [updateEntry] = useUpdateInspectionEntryMutation()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleChange = async (status: InspectionEntryStatusEntry) => {
    const updatedEntry = {
      ...entry,
      info: {
        ...entry.info!,
        customStatus:
          status.id === EntryInfoStatusEnum.NotInspected
            ? undefined
            : status.id,
        complete:
          status.id === EntryInfoStatusEnum.NotInspected
            ? undefined
            : new Date()
      },
      status
    }
    // update UI before api call
    setEntry(updatedEntry)
    setAnchorEl(null)
    updateEntry({
      authorization: accessToken,
      entryEntry: updatedEntry
    })
  }

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget)
  }

  return (
    <>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}>
        {allStatuses?.map((status) => (
          <MenuItem key={status.id} onClick={handleChange.bind(null, status)}>
            {status.info?.title}
          </MenuItem>
        ))}
      </Menu>
      <InspectionEntryStatusChip status={entry.status} onClick={handleClick} />
    </>
  )
}
